import apiBase from "./apiBase";

export default {
  getSettings: async () => {
    let response = await apiBase.callService(
      "General/Settings",
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getScreenMessages: async (testAttemptId, localeId) => {
    const url = `General/ScreenMessages?testAttemptId=${testAttemptId}&localeId=${localeId}`;
    let response = await apiBase.callServiceSecure(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  getPracticeTest: async (testAttemptId, localeId) => {
    const url = `General/PracticeTest?testAttemptId=${testAttemptId}&localeId=${localeId}`;
    let response = await apiBase.callServiceSecure(
      url,
      null,
      apiBase.methodTypes.get
    );
    return response.data;
  },
  checkStatus: async () => {
    let status = await apiBase.callService(
      "General/Status",
      null,
      apiBase.methodTypes.get
    );
    return status.data;
  },
};
